import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { PhoneSettingsResponse } from '../../../models/responses/phone-settings-response';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormModuleTemplate } from '../../../module-templates/form-module-template';
import { PhoneSettingsService } from '../../../services/phone-settings.service';
import { PhoneSettingsImportRequest } from '../../../models/requests/phone-settings-import-request';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgIf } from '@angular/common';
import { UserPhoneNumbersPageEventsService } from '../../../events/user-integrations-page-events.service';

@Component({
  selector: 'app-import-twilio-phone-number-dialog',
  standalone: true,
  imports: [
    FormModuleTemplate,
    MatDialogModule,
    NgIf
  ],
  templateUrl: './import-twilio-phone-number-dialog.component.html',
  styleUrl: './import-twilio-phone-number-dialog.component.scss'
})
export class ImportTwilioPhoneNumberDialogComponent {
  importForm!: FormGroup;
  phoneSettings!: PhoneSettingsResponse;
  isLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ImportTwilioPhoneNumberDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { phoneSettings: PhoneSettingsResponse },
    private formBuilder: FormBuilder,
    private phoneSettingsService: PhoneSettingsService,
    private userPhoneNumberPageEventService: UserPhoneNumbersPageEventsService,
    private snackBar: MatSnackBar
  ) {
    if (this.data) {
      this.phoneSettings = this.data.phoneSettings;
    }
  }

  ngOnInit() {
    this.initImportForm();
  }

  initImportForm() {
    this.importForm = this.formBuilder.group({
      phoneNumber: [this.phoneSettings ? this.phoneSettings.phoneNumber : ''],
      phoneSid: [this.phoneSettings ? this.phoneSettings.phoneSid : ''],
      accountToken: [this.phoneSettings ? this.phoneSettings.accountToken : ''],
      accountSID: [this.phoneSettings ? this.phoneSettings.accountSID : '']
    });
  }

  onImportTwilio() {
    if (this.importForm.valid) {
      const formValue = this.importForm.value;
      const request: PhoneSettingsImportRequest = {
        phoneSettingsId: this.phoneSettings? this.phoneSettings.id : -1,
        phoneNumber: formValue['phoneNumber'].replace(/\s/g, ""),
        phoneSid: formValue['phoneSid'],
        accountToken: formValue['accountToken'],
        accountSID: formValue['accountSID'],
      }

      if (this.phoneSettings) {
        this.updateTwilioPhoneNumber(request);
      } else {
        this.importTwilioPhoneNumber(request);
      }
    }
  }

  importTwilioPhoneNumber(request: PhoneSettingsImportRequest) {
    this.isLoading = true;

    this.phoneSettingsService.importTwilioPhoneNumberToUser(request).subscribe({
      next: () => { 
        this.userPhoneNumberPageEventService.OnPhoneNumbersRefreshEvent.emit();
        this.isLoading = false;
        this.openSnackBar('Phone number imported successfully');
        this.dialogRef.close();
      },
      error: () => {
        this.isLoading = false;
        alert('Server Error contact support');
      }
    });
  }
  
  updateTwilioPhoneNumber(request: PhoneSettingsImportRequest) {
    this.isLoading = true;
    
    this.phoneSettingsService.updateImportedPhoneNumber(request).subscribe({ 
      next: () => {
        this.userPhoneNumberPageEventService.OnPhoneNumbersRefreshEvent.emit();
        this.isLoading = false;
        this.openSnackBar('Phone number updated successfully');
        this.dialogRef.close();
        
      },
      error: () => {
        this.isLoading = false;
        alert('Server Error contact support');
      }
      });
  }

  openSnackBar(message: string) {
    this.snackBar.open(message, 'close', { duration: 5000 });
  }
}
